import classNames from "classnames";
import { Color } from "utils/theme";

interface Props {
  label?: string;
  color: "green" | "red";
  pulse?: boolean;
  props?: unknown;
  className?: string;
}

const StatusChip = ({
  label,
  color = "green",
  pulse = false,
  className = "",
  ...props
}: Props) => {
  const getColor = () => {
    switch (color) {
      case "green":
        return {
          background: Color.Emerald[400],
          borderColor: Color.Primary[800],
        };
      case "red":
        return {
          background: Color.Rose[500],
          borderColor: Color.Primary[800],
        };
      default:
        return {
          background: Color.Emerald[400],
          borderColor: Color.Primary[800],
        };
    }
  };

  return (
    <div className={classNames("flex items-center", className)} {...props}>
      <span
        className={classNames("w-3 h-3 rounded-full ring-4 border-[2px]", {
          "ring-emerald-400/20": color === "green",
          " ring-rose-400/20": color === "red",
          "animate-pulse": pulse,
        })}
        style={getColor()}
      />
      {label && (
        <p className={"overflow-hidden text-ellipsis whitespace-nowrap ml-3"}>
          {label}
        </p>
      )}
    </div>
  );
};

export default StatusChip;
